<script setup lang="ts">
import {Ref, toRef} from "vue";
import {CreatePaymentFlow} from "@/views/payment-create-config/NewPaymentController";

interface IProps {
	flow: CreatePaymentFlow;
}

const props = defineProps<IProps>();
const emits = defineEmits(['update'])
const flow: Ref<CreatePaymentFlow> = toRef(props, 'flow');

function updateFlow(flow: CreatePaymentFlow) {
    emits('update', flow);
}
</script>

<template>
    <div class="view-payment-create-flow-tabs">
        <f7-link
            class="view-payment-create-flow-tabs__classic"
            :tab-link="`#flow-${CreatePaymentFlow.classic}`"
            :tab-link-active="flow === CreatePaymentFlow.classic"
            @click="updateFlow(CreatePaymentFlow.classic)"
        >
            {{ $t('newPayment.classic-flow.tab-title') }}
        </f7-link>
        <f7-link
            class="view-payment-create-flow-tabs__from-bromoney"
            :tab-link="`#flow-${CreatePaymentFlow.fromBromoney}`"
            :tab-link-active="flow === CreatePaymentFlow.fromBromoney"
            @click="updateFlow(CreatePaymentFlow.fromBromoney)"
        >
            {{ $t('newPayment.from-bromoney-flow.tab-title') }}
        </f7-link>
    </div>
</template>

<style lang="scss">
.view-payment-create-flow-tabs {
    display: flex;
    gap: 12px;
    padding: 0 12px;
    margin: 24px 0 0 0;

    & + .tabs.with-fractional-number-warning {
        //margin-bottom: 16px;
    }

    &__classic {
        flex: 1;
        display: flex;
        align-content: center;
        justify-content: center;
        height: 71px;
        background-color: var(--white1);
        border-radius: 8px;
        border: 1px solid var(--grey4);

        &.tab-link-active {
            border: 1px solid var(--blue1);
        }
    }

    &__from-bromoney {
        flex: 1;
        display: flex;
        align-content: center;
        justify-content: center;
        height: 71px;
        background-color: var(--white1);
        border-radius: 8px;
        border: 1px solid var(--grey4);

        &.tab-link-active {
            border: 1px solid var(--blue1);
        }
    }

    a {
        padding: 0 8px;
        text-align: center;
        @include text(14px, 500, var(--brown1), 120%);
        @media (min-width: 375px) {
            @include text(16px, 500, var(--brown1), 120%);
        }
    }
}
</style>
